export class Organization {
  id: number;
  name: string;
  legalEntity: string;
  type: string;
  parent: number;
  status: string;
  domain: string;
  logo: string;
  createdBy: string;
  updatedBy: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  twoFactorType:boolean;
  segment:string;
}


export class Domain {
  id: number;
  domain: string;
  isDeleted: boolean;
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/objects/organization.ts